export default __webpack_public_path__ + "static/media/antp_SeguridadPrivada_MINIATURA_.0e093ffc.jpg";